import { ArrowUpRight } from "lucide-react";
import { CONTACT, LOGOS, NAV_LINKS } from "@/lib/site";

export default function Footer() {
  return (
    <footer className="relative -mt-8 rounded-t-[48px] bg-[#F1ECFE] border-t border-[#0B132B]/[0.06] overflow-hidden" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-16 pb-10 relative">
        <div className="grid md:grid-cols-12 gap-10 mb-14">
          <div className="md:col-span-5">
            <img src={LOGOS.expante} alt="Expante - Global Consulting" className="h-12 w-auto mb-6" />
            <p className="text-sm text-[#475569] leading-relaxed max-w-sm">
              Expante helps international businesses build and scale their teams in India—with the
              operating support to grow from EOR to ODC, Centre of Excellence, or GCC models.
            </p>
            <div className="mt-6 inline-flex items-center gap-2.5 rounded-full border border-[#0B132B]/10 bg-white px-4 py-2 shadow-sm">
              <img src={LOGOS.lionforce} alt="" className="h-4 w-4 object-contain" />
              <span className="text-xs text-[#475569]" data-testid="footer-attribution">
                Expante is operated by <span className="text-[#0B132B] font-semibold">Lionforce Technologies Pvt Ltd.</span>
              </span>
            </div>
          </div>

          <div className="md:col-span-3">
            <p className="text-[11px] font-mono-tech uppercase tracking-[0.2em] text-[#94A3B8] mb-5">Explore</p>
            <ul className="space-y-3">
              {NAV_LINKS.map((l) => (
                <li key={l.href}>
                  <a href={l.href} className="text-sm text-[#475569] hover:text-[#5B4199] transition-colors">
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <p className="text-[11px] font-mono-tech uppercase tracking-[0.2em] text-[#94A3B8] mb-5">Contact</p>
            <ul className="space-y-3 text-sm">
              <li>
                <a href={CONTACT.phoneHref} className="text-[#475569] hover:text-[#5B4199] transition-colors" data-testid="footer-phone-link">
                  {CONTACT.phoneDisplay}
                </a>
              </li>
              <li>
                <a href={CONTACT.emailHref} className="text-[#475569] hover:text-[#5B4199] transition-colors" data-testid="footer-email-link">
                  {CONTACT.email}
                </a>
              </li>
              <li>
                <address className="not-italic text-[#475569] leading-relaxed" data-testid="footer-address">
                  {CONTACT.addressLines.map((l) => (
                    <span key={l} className="block">{l}</span>
                  ))}
                </address>
              </li>
            </ul>
            <a
              href="#contact"
              className="mt-6 inline-flex items-center gap-1.5 text-sm font-semibold text-[#5B4199] hover:text-[#0B132B] transition-colors"
              data-testid="footer-cta-link"
            >
              Schedule a consultation
              <ArrowUpRight className="h-4 w-4" />
            </a>
          </div>
        </div>

        <div aria-hidden="true" className="select-none pointer-events-none -mx-4 overflow-hidden">
          <p className="font-display font-extrabold uppercase leading-[0.85] tracking-tight text-stroke-ghost text-[clamp(80px,15vw,210px)] text-center">
            Expante
          </p>
        </div>

        <div className="mt-8 pt-8 border-t border-[#0B132B]/[0.08] flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-[#6B7488]">
            © {new Date().getFullYear()} Expante - Operated by Lionforce Technologies Pvt Ltd. All rights reserved.
          </p>
          <div className="flex items-center gap-5">
            <a href="/privacy" className="text-xs font-semibold text-[#64748B] hover:text-[#5B4199] transition-colors" data-testid="footer-privacy-link">
              Privacy Policy
            </a>
            <p className="text-xs text-[#94A3B8] font-mono-tech tracking-[0.12em] uppercase">
              Big teams start here.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
